import { useState } from "react";

/** Props Interface */
interface UseDisclosureProps {
	defaultIsOpen?: boolean;
}

export function useDisclosure<T extends string>(props?: UseDisclosureProps) {
	/** State */
	const [targetValue, setTargetValue] = useState<T | null>(null);
	const [isOpen, setIsOpen] = useState<boolean>(props?.defaultIsOpen ?? false);

	/** Functions */
	function onClose() {
		setIsOpen(false);
		setTargetValue(null);
	}

	function onOpen(value?: T | null | object) {
		if (value) {
			if (typeof value === "string") {
				setTargetValue(value);
			}
		}
		setIsOpen(true);
	}

	function onToggle() {
		setIsOpen(!isOpen);
	}

	/** Return */
	return {
		isOpen,
		setIsOpen,
		onClose,
		onOpen,
		onToggle,
		targetValue,
	};
}

export type Disclosure = ReturnType<typeof useDisclosure>;
